import {
  Box,
  Button,
  chakra,
  Divider,
  FormControl,
  FormHelperText,
  FormLabel,
  Input,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Text,
  Textarea,
} from '@chakra-ui/react'
import { yupResolver } from '@hookform/resolvers/yup'
import { messageTemplateVariables } from 'ai-constants'
import React, { useCallback, useContext, useRef } from 'react'
import { useForm } from 'react-hook-form'
import { GoLinkExternal } from 'react-icons/go'
import { MdAddCircleOutline } from 'react-icons/md'
import { TransitionAllStyles } from '../constants/prebuild-styles'
import {
  DeliveryChannel,
  IMessageTemplate,
  MessageTemplateCtx,
  useMessageTemplate,
} from '../providers/MessageTemplate.provider'
import {
  IMessageTemplateSchema,
  MessageTemplateSchema,
} from '../schemas/message-template.schema'
import { TranslatorOnlyString } from './Translator'

interface IMessage {
  footer?: string | null | undefined
  body: string
  subject: string
}

const EmailPreview = (props: IMessageTemplateSchema) => {
  const { logo, buttonBackgroundColor, buttonForegroundColor } =
    useMessageTemplate()

  return (
    <table
      role='presentation'
      style={{
        width: '100%',
        borderCollapse: 'collapse',
        border: 0,
        borderSpacing: 0,
      }}
    >
      <tbody>
        <tr>
          <td className='external-container' align='center' valign='top'>
            <table
              role='presentation'
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                borderSpacing: 0,
                background: '#ffffff',
                borderRadius: '4px',
              }}
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align='center'>
                    <table
                      className='container'
                      width='100%'
                      style={{ padding: '0 30px' }}
                      border={0}
                      cellSpacing={0}
                      cellPadding={0}
                    >
                      <tbody>
                        <tr>
                          <td
                            className='td'
                            style={{
                              fontSize: '0pt',
                              lineHeight: '0pt',
                              padding: '10px',
                              margin: 0,
                              fontWeight: 'normal',
                            }}
                          >
                            <table
                              width='100%'
                              border={0}
                              cellSpacing={0}
                              cellPadding={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    className='p30-15 tbrr'
                                    style={{
                                      padding: '15px 0px 0px 0px',
                                      borderRadius: '12px 12px 0px 0px',
                                    }}
                                  >
                                    <table
                                      width='100%'
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <th
                                            style={{
                                              width: 145,
                                              fontSize: '0pt',
                                              lineHeight: '0pt',
                                              padding: 0,
                                              margin: 0,
                                              fontWeight: 'normal',
                                              verticalAlign: 'top',
                                            }}
                                          >
                                            <table
                                              width='100%'
                                              border={0}
                                              cellSpacing={0}
                                              cellPadding={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    className='img'
                                                    style={{
                                                      fontSize: '0pt',
                                                      lineHeight: '0pt',
                                                      textAlign: 'left',
                                                      paddingRight: '8px',
                                                    }}
                                                  >
                                                    <img
                                                      src={
                                                        logo ||
                                                        '/assets/icon-192x192.png'
                                                      }
                                                      alt='Logo'
                                                      style={{
                                                        width: 100,
                                                        height: 40,
                                                        display: 'block',
                                                        objectFit: 'contain',
                                                      }}
                                                    />
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </th>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <table
                              width='100%'
                              border={0}
                              cellSpacing={0}
                              cellPadding={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    className='p30-15'
                                    style={{ padding: '40px 0px 0px 0px' }}
                                  >
                                    <table
                                      width='100%'
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td
                                            className='h3 pb15'
                                            style={{
                                              color: '#23496d',
                                              fontFamily: 'Roboto, sans-serif',
                                              fontSize: '18px',
                                              lineHeight: '28px',
                                              textAlign: 'left',
                                              paddingBottom: '10px',
                                              fontWeight: 'bold',
                                            }}
                                          >
                                            {props.subject}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            className='text pb15'
                                            style={{
                                              color: '#23496d',
                                              fontFamily: 'Roboto, sans-serif',
                                              fontSize: '14px',
                                              lineHeight: '20px',
                                              textAlign: 'left',
                                              paddingBottom: '15px',
                                            }}
                                            dangerouslySetInnerHTML={{
                                              __html: props.body.replaceAll(
                                                '\n',
                                                '<br/>',
                                              ),
                                            }}
                                          />
                                        </tr>
                                        <tr>
                                          <td
                                            style={{
                                              padding: '100px 0 40px 0',
                                            }}
                                            align='center'
                                          >
                                            <table
                                              role='presentation'
                                              style={{
                                                width: '100%',
                                                borderCollapse: 'collapse',
                                                border: 0,
                                                borderSpacing: 0,
                                                fontSize: '9px',
                                                fontFamily: 'Roboto,sans-serif',
                                              }}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    style={{ padding: 0 }}
                                                    align='center'
                                                  >
                                                    <p
                                                      style={{
                                                        margin: 0,
                                                        lineHeight: '16px',
                                                        fontFamily:
                                                          'Roboto,sans-serif',
                                                        color: '#ffffff',
                                                        textAlign: 'center',
                                                      }}
                                                    >
                                                      <a
                                                        target='_blank'
                                                        style={{
                                                          padding: '12px 25px',
                                                          borderRadius: '4px',
                                                          fontSize: '16px',
                                                          fontWeight: 600,
                                                          color:
                                                            buttonForegroundColor ||
                                                            '#ffffff !important',
                                                          textDecoration:
                                                            'none',
                                                          background:
                                                            buttonBackgroundColor ||
                                                            'hsl(var(--primary))',
                                                        }}
                                                      >
                                                        {props.buttonLabel}
                                                      </a>
                                                    </p>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    align='center'
                                    className='img'
                                    style={{
                                      fontSize: '0pt',
                                      lineHeight: '0pt',
                                      textAlign: 'center',
                                      paddingBottom: '20px',
                                      paddingTop: '20px',
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: '100%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                      }}
                                    >
                                      <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        xmlSpace='preserve'
                                        id='Capa_1'
                                        x={0}
                                        y={0}
                                        viewBox='0 0 614.37 168.31'
                                        width={'6rem'}
                                      >
                                        <style>
                                          {
                                            '.st0{fill:#8b5cf6}.st1{fill:#334155}'
                                          }
                                        </style>
                                        <path
                                          d='M13.7 127.53c0-8.64 6.91-13.13 16.24-13.13H42.9v-2.76c0-4.92-2.94-8.21-9.16-8.21-6.13 0-9.16 3.2-10.19 7.77l-8.29-2.68C17.33 101.78 22.95 96 33.83 96c11.06 0 17.79 5.87 17.79 16.24v17.53c0 1.73.86 2.59 2.42 2.59h3.63v7.43h-6.65c-3.97 0-6.74-2.25-6.74-5.79v-.26H42.9c-1.3 2.76-4.41 7.26-13.22 7.26-9.07.01-15.98-4.83-15.98-13.47zm29.2-5.35v-.86H30.46c-4.75 0-7.86 2.07-7.86 5.96s3.11 6.39 8.38 6.39c7.08 0 11.92-4.32 11.92-11.49zM64.76 122.78V97.22h8.9v24.96c0 7.34 3.89 10.8 10.45 10.8 7.34 0 12.09-5.01 12.09-14.25V97.22h8.9v42.58h-8.72v-6.39H95c-1.64 3.54-5.36 7.17-13.47 7.17-9.78 0-16.77-6.83-16.77-17.8zM125.74 131.25v-26.52h-11.75v-7.51h11.75V83.14h8.9v14.08h12.7v7.51h-12.7v24.96c0 1.73.78 2.59 2.42 2.59h8.9v7.51h-11.75c-5.27.01-8.47-3.27-8.47-8.54zM154.16 119.16v-1.3c0-13.47 9.24-21.85 22.03-21.85 12.78 0 22.11 8.38 22.11 21.85v1.3c0 13.56-9.33 21.85-22.11 21.85-12.79 0-22.03-8.29-22.03-21.85zm35.24-.26v-.78c0-8.81-5.36-14.17-13.21-14.17-7.77 0-13.13 5.36-13.13 14.17v.78c0 8.9 5.36 14.17 13.13 14.17 7.77-.01 13.21-5.28 13.21-14.17zM207.72 85.38c0-3.63 2.59-6.05 6.13-6.05 3.45 0 6.13 2.42 6.13 6.05s-2.68 6.05-6.13 6.05c-3.54 0-6.13-2.42-6.13-6.05zm1.64 11.84h8.9v42.58h-8.9V97.22zM231.47 97.22h8.72v6.39h1.38c1.64-3.46 5.36-7.08 13.56-7.08 9.67 0 16.67 6.74 16.67 17.71v25.57h-8.9v-24.88c0-7.43-3.89-10.8-10.37-10.8-7.34 0-12.18 5.01-12.18 14.17v21.51h-8.9V97.22zM282 126.41l8.29-1.99c1.21 7.17 6.05 9.41 11.75 9.41 5.61 0 8.81-2.33 8.81-5.87 0-3.45-2.94-4.75-8.46-5.79l-3.02-.52c-8.64-1.55-15.55-4.92-15.55-12.96s6.48-12.7 16.41-12.7c9.59 0 15.98 4.58 17.79 12.01l-8.29 2.33c-.95-5.18-4.49-7.08-9.5-7.08-4.92 0-7.77 1.9-7.77 5.1 0 3.46 2.85 4.75 7.51 5.61l3.02.52c9.24 1.64 16.58 4.41 16.58 13.04 0 8.55-6.91 13.47-17.53 13.47-10.88.02-18.48-4.82-20.04-14.58zM329.95 97.22h8.72v6.13h1.38c2.16-3.8 6.22-7.34 14.51-7.34 10.62 0 19.69 8.12 19.69 21.85v1.3c0 13.73-8.98 21.85-19.69 21.85-8.29 0-12.35-3.54-14.34-7h-1.38v23.06h-8.9V97.22zm35.32 21.68v-.78c0-9.16-5.61-14.25-13.3-14.25-7.6 0-13.21 5.1-13.21 14.25v.78c0 9.16 5.53 14.34 13.21 14.34 7.78 0 13.3-5.19 13.3-14.34zM383.24 119.07v-1.04c0-13.3 8.72-22.02 21.25-22.02 12.27 0 20.56 8.64 20.56 21.59v3.37h-32.74c.26 7.51 5.53 12.26 12.7 12.26 6.74 0 9.67-3.45 11.49-7.43l7.43 3.8c-2.59 4.92-7.6 11.4-19.09 11.4-12.96.01-21.6-8.71-21.6-21.93zm32.83-4.92c-.52-6.39-5.01-10.28-11.66-10.28-6.74 0-11.14 3.89-12.01 10.28h23.67zM433.69 119.07v-1.12c0-13.73 9.5-21.94 21.85-21.94 12.26 0 19.17 7.43 20.82 16.41l-8.64 1.81c-.78-5.7-4.49-10.28-12.01-10.28-7.43 0-13.13 5.18-13.13 14.17v.78c0 8.98 5.7 14.17 13.13 14.17 7.51 0 11.23-4.32 12.26-10.28l8.64 1.99c-1.99 8.9-8.81 16.24-21.07 16.24-12.35-.01-21.85-8.13-21.85-21.95zM492.86 131.25v-26.52h-11.75v-7.51h11.75V83.14h8.9v14.08h12.7v7.51h-12.7v24.96c0 1.73.78 2.59 2.42 2.59h8.9v7.51h-11.75c-5.27.01-8.47-3.27-8.47-8.54zM521.28 119.16v-1.3c0-13.47 9.24-21.85 22.03-21.85 12.78 0 22.11 8.38 22.11 21.85v1.3c0 13.56-9.33 21.85-22.11 21.85-12.79 0-22.03-8.29-22.03-21.85zm35.24-.26v-.78c0-8.81-5.36-14.17-13.21-14.17-7.77 0-13.13 5.36-13.13 14.17v.78c0 8.9 5.36 14.17 13.13 14.17 7.77-.01 13.21-5.28 13.21-14.17zM576.48 97.22h8.72v5.01h1.38c1.38-3.54 4.41-5.18 8.98-5.18h5.1v8.03h-5.44c-5.79 0-9.85 3.11-9.85 9.67v25.05h-8.9V97.22z'
                                          className='st0'
                                        />
                                        <path
                                          d='M140.03 23.65h6.06v4.26h.96c1.5-2.64 4.32-5.1 10.08-5.1 7.38 0 13.68 5.64 13.68 15.18v.9c0 9.54-6.24 15.18-13.68 15.18-5.76 0-8.58-2.46-9.96-4.86h-.96v16.02h-6.18V23.65zm24.53 15.06v-.54c0-6.36-3.9-9.9-9.24-9.9-5.28 0-9.18 3.54-9.18 9.9v.54c0 6.36 3.84 9.96 9.18 9.96 5.4 0 9.24-3.6 9.24-9.96zM177.04 38.89v-.9c0-9.36 6.42-15.18 15.3-15.18s15.36 5.82 15.36 15.18v.9c0 9.42-6.48 15.18-15.36 15.18-8.88 0-15.3-5.76-15.3-15.18zm24.48-.18v-.54c0-6.12-3.72-9.84-9.18-9.84-5.4 0-9.12 3.72-9.12 9.84v.54c0 6.18 3.72 9.84 9.12 9.84 5.4 0 9.18-3.66 9.18-9.84zM213.22 23.65h6.18l3.72 25.44h.96l5.16-25.44h10.02l5.1 25.44h.96l3.72-25.44h6.18l-5.04 29.58h-10.32l-5.16-25.38h-.96l-5.1 25.38h-10.38l-5.04-29.58zM260.74 38.83v-.72c0-9.24 6.06-15.3 14.76-15.3 8.52 0 14.28 6 14.28 15v2.34h-22.74c.18 5.22 3.84 8.52 8.82 8.52 4.68 0 6.72-2.4 7.98-5.16l5.16 2.64c-1.8 3.42-5.28 7.92-13.26 7.92-9 0-15-6.06-15-15.24zm22.8-3.42c-.36-4.44-3.48-7.14-8.1-7.14-4.68 0-7.74 2.7-8.34 7.14h16.44zM297.22 23.65h6.06v3.48h.96c.96-2.46 3.06-3.6 6.24-3.6h3.54v5.58h-3.78c-4.02 0-6.84 2.16-6.84 6.72v17.4h-6.18V23.65zM317.92 38.83v-.72c0-9.24 6.06-15.3 14.76-15.3 8.52 0 14.28 6 14.28 15v2.34h-22.74c.18 5.22 3.84 8.52 8.82 8.52 4.68 0 6.72-2.4 7.98-5.16l5.16 2.64c-1.8 3.42-5.28 7.92-13.26 7.92-9 0-15-6.06-15-15.24zm22.8-3.42c-.36-4.44-3.48-7.14-8.1-7.14-4.68 0-7.74 2.7-8.34 7.14h16.44zM352.96 38.89v-.9c0-9.54 6.24-15.18 13.68-15.18 5.76 0 8.58 2.46 9.96 4.86h.96V11.24h6.18v42h-6.06v-4.2h-.96c-1.5 2.58-4.32 5.04-10.08 5.04-7.38-.01-13.68-5.59-13.68-15.19zm24.66-.18v-.54c0-6.36-3.84-9.9-9.24-9.9-5.34 0-9.18 3.54-9.18 9.9v.54c0 6.36 3.9 9.96 9.18 9.96 5.34 0 9.24-3.6 9.24-9.96zM415.18 49.03h-.96v4.2h-6.06v-42h6.18v16.44h.96c1.38-2.4 4.2-4.86 9.96-4.86 7.44 0 13.68 5.64 13.68 15.18v.9c0 9.6-6.3 15.18-13.68 15.18-5.76 0-8.58-2.46-10.08-5.04zm17.52-10.32v-.54c0-6.36-3.84-9.9-9.24-9.9-5.34 0-9.18 3.54-9.18 9.9v.54c0 6.36 3.9 9.96 9.18 9.96 5.34 0 9.24-3.6 9.24-9.96zM450.04 59.83h16.5c1.14 0 1.68-.6 1.68-1.8v-9.12h-.96c-1.08 2.34-3.66 4.86-9.3 4.86-6.78 0-11.64-4.68-11.64-12.3V23.65h6.18v17.34c0 5.16 2.7 7.5 7.26 7.5 5.1 0 8.4-3.48 8.4-9.84v-15h6.18v35.64c0 3.66-2.28 5.94-5.94 5.94h-18.36v-5.4z'
                                          className='st1'
                                        />
                                      </svg>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    height={1}
                                    className='img'
                                    style={{
                                      fontSize: '0pt',
                                      lineHeight: '0pt',
                                      textAlign: 'left',
                                    }}
                                  >
                                    &nbsp;
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    className='pb40'
                                    style={{ paddingBottom: '0px' }}
                                  />
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  )
}

const SMSPreview = (props: IMessage) => {
  return (
    <div className='container'>
      <style
        //@ts-ignore
        jsx={true}
        global
      >
        {`
          .container {
            padding: 10px;
          }

          .message-blue {
            position: relative;
            margin-left: 20px;
            margin-bottom: 20px;
            padding: 10px;
            padding-bottom: 25px;
            text-align: left;
            font: 400 0.875rem 'Open Sans', sans-serif;
            border-radius: 10px;
          }

          .message-orange {
            position: relative;
            margin-bottom: 10px;
            margin-left: calc(100% - 240px);
            padding: 10px;
            background-color: #f8e896;
            width: 200px;
            height: 50px;
            text-align: left;
            font: 400 0.9em 'Open Sans', sans-serif;
            border: 1px solid #dfd087;
            border-radius: 10px;
          }

          .message-content {
            padding: 0;
            margin: 0;
          }

          .message-timestamp-right {
            position: absolute;
            font-size: 0.85em;
            font-weight: 300;
            bottom: 5px;
            right: 5px;
          }

          .message-timestamp-left {
            position: absolute;
            font-size: 0.85em;
            font-weight: 300;
            bottom: 5px;
            left: 5px;
          }

          .message-blue:after {
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            border-left: 15px solid transparent;
            border-right: 15px solid transparent;
            top: 0;
            left: -15px;
          }

          .message-blue:before {
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            border-left: 16px solid transparent;
            border-right: 16px solid transparent;
            top: -1px;
            left: -17px;
          }

          .message-orange:after {
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            border-bottom: 15px solid #f8e896;
            border-left: 15px solid transparent;
            border-right: 15px solid transparent;
            bottom: 0;
            right: -15px;
          }

          .message-orange:before {
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            border-bottom: 17px solid #dfd087;
            border-left: 16px solid transparent;
            border-right: 16px solid transparent;
            bottom: -1px;
            right: -17px;
          }
        `}
      </style>
      <div className='message-blue w-[150px] lg:w-[200px] xl:w-[250px] 2xl:w-[350px] relative text-sm space-y-1 bg-zinc-100 border-1 border-zinc-100 after:border-t-[15px] after:border-t-zinc-100 before:border-t-[17px] before:border-t-zinc-100'>
        <p className='message-content'>{props.subject}</p>
        <p className='message-content'>{props.body}</p>
        <p className='message-content'>
          https://app.autoinspector.ai/63971f5639ba1e1ca05e1e1c?accessCode=1234
        </p>
        <br />
        <div className='absolute right-2 bottom-2'>
          <p className='text-xs'>SMS 13:37</p>
        </div>
      </div>
    </div>
  )
}

const WhatsappPreview = (props: IMessage) => {
  return (
    <div className='page'>
      <style
        //@ts-ignore
        global={true}
        jsx
      >
        {`
          .page {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .screen {
            height: 20rem;
          }

          .marvel-device .screen {
            text-align: left;
          }

          .screen-container {
            height: 100%;
          }

          .status-bar {
            height: 25px;
            background: #004e45;
            color: #fff;
            font-size: 14px;
            padding: 0 8px;
          }

          .status-bar:after {
            content: '';
            display: table;
            clear: both;
          }

          .status-bar div {
            float: right;
            position: relative;
            top: 50%;
            transform: translateY(-50%);
            margin: 0 0 0 8px;
            font-weight: 600;
          }

          /* Chat */

          .chat {
            height: calc(100% - 69px);
          }

          .chat-container {
            height: 100%;
          }

          /* User Bar */

          .user-bar {
            height: 55px;
            background: #005e54;
            color: #fff;
            padding: 0 8px;
            font-size: 24px;
            position: relative;
            z-index: 1;
          }

          .user-bar:after {
            content: '';
            display: table;
            clear: both;
          }

          .user-bar div {
            float: left;
            transform: translateY(-50%);
            position: relative;
            top: 50%;
          }

          .user-bar .actions {
            float: right;
            margin: 0 0 0 20px;
          }

          .user-bar .actions.more {
            margin: 0 12px 0 32px;
          }

          .user-bar .actions.attachment {
            margin: 0 0 0 30px;
          }

          .user-bar .actions.attachment i {
            display: block;
            transform: rotate(-45deg);
          }

          .user-bar .avatar {
            margin: 0 0 0 5px;
            width: 36px;
            height: 36px;
          }

          .user-bar .avatar img {
            border-radius: 50%;
            box-shadow: 0 1px 0 rgba(255, 255, 255, 0.1);
            display: block;
            width: 100%;
          }

          .user-bar .name {
            font-size: 17px;
            font-weight: 600;
            letter-spacing: 0.3px;
            margin: 0 0 0 8px;
            overflow: hidden;
            white-space: nowrap;
            width: 200px;
          }

          .user-bar .status {
            display: block;
            font-size: 13px;
            font-weight: 400;
            letter-spacing: 0;
          }

          .conversation {
            height: calc(100% - 12px);
            position: relative;
            background: #efe7dd url('/assets/wsp-bg.jpg') repeat;
            z-index: 0;
          }

          .conversation .conversation-container {
            height: calc(100% - 68px);
            box-shadow: inset 0 10px 10px -10px #000000;
            padding: 0 16px;
            margin-bottom: 5px;
          }

          .conversation .conversation-container:after {
            content: '';
            display: table;
            clear: both;
          }

          /* Messages */

          .message {
            color: #000;
            clear: both;
            line-height: 18px;
            font-size: 15px;
            padding: 8px;
            position: relative;
            margin: 8px 0;
            max-width: 85%;
            word-wrap: break-word;
            z-index: -1;
          }

          .message:after {
            position: absolute;
            content: '';
            width: 0;
            height: 0;
            border-style: solid;
          }

          .metadata {
            display: inline-block;
            float: right;
            padding: 0 0 0 7px;
            position: relative;
            bottom: -4px;
          }

          .metadata .time {
            color: rgba(0, 0, 0, 0.45);
            font-size: 11px;
            display: inline-block;
          }

          .metadata .tick {
            display: inline-block;
            margin-left: 2px;
            position: relative;
            top: 4px;
            height: 16px;
            width: 16px;
          }

          .metadata .tick svg {
            position: absolute;
            transition: 0.5s ease-in-out;
          }

          .metadata .tick svg:first-child {
            -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
            -webkit-transform: perspective(800px) rotateY(180deg);
            transform: perspective(800px) rotateY(180deg);
          }

          .metadata .tick svg:last-child {
            -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
            -webkit-transform: perspective(800px) rotateY(0deg);
            transform: perspective(800px) rotateY(0deg);
          }

          .metadata .tick-animation svg:first-child {
            -webkit-transform: perspective(800px) rotateY(0);
            transform: perspective(800px) rotateY(0);
          }

          .metadata .tick-animation svg:last-child {
            -webkit-transform: perspective(800px) rotateY(-179.9deg);
            transform: perspective(800px) rotateY(-179.9deg);
          }

          .message:first-child {
            margin: 16px 0 8px;
          }

          .message.received {
            background: #fff;
            border-radius: 0px 5px 5px 5px;
            float: left;
          }

          .message.received .metadata {
            padding: 0 0 0 16px;
          }

          .message.received:after {
            border-width: 0px 10px 10px 0;
            border-color: transparent #fff transparent transparent;
            top: 0;
            left: -10px;
          }

          .message.sent {
            background: #e1ffc7;
            border-radius: 5px 0px 5px 5px;
            float: right;
          }

          .message.sent:after {
            border-width: 0px 0 10px 10px;
            border-color: transparent transparent transparent #e1ffc7;
            top: 0;
            right: -10px;
          }

          /* Compose */

          .conversation-compose {
            display: flex;
            flex-direction: row;
            align-items: flex-end;
            overflow: hidden;
            height: 50px;
            width: 100%;
            z-index: 2;
          }

          .conversation-compose div,
          .conversation-compose input {
            background: #fff;
            height: 100%;
          }

          .conversation-compose .emoji {
            display: flex;
            align-items: center;
            justify-content: center;
            background: white;
            border-radius: 5px 0 0 5px;
            flex: 0 0 auto;
            margin-left: 8px;
            width: 48px;
          }

          .conversation-compose .input-msg {
            border: 0;
            flex: 1 1 auto;
            font-size: 16px;
            margin: 0;
            outline: none;
            min-width: 50px;
          }

          .conversation-compose .photo {
            flex: 0 0 auto;
            border-radius: 0 0 5px 0;
            text-align: center;
            position: relative;
            width: 48px;
          }

          .conversation-compose .photo:after {
            border-width: 0px 0 10px 10px;
            border-color: transparent transparent transparent #fff;
            border-style: solid;
            position: absolute;
            width: 0;
            height: 0;
            content: '';
            top: 0;
            right: -10px;
          }

          .conversation-compose .photo i {
            display: block;
            color: #7d8488;
            font-size: 24px;
            transform: translate(-50%, -50%);
            position: relative;
            top: 50%;
            left: 50%;
          }

          .conversation-compose .send {
            background: transparent;
            border: 0;
            cursor: pointer;
            flex: 0 0 auto;
            margin-left: 8px;
            margin-right: 8px;
            padding: 0;
            position: relative;
            outline: none;
          }

          .conversation-compose .send .circle {
            background: #008a7c;
            border-radius: 50%;
            color: #fff;
            position: relative;
            width: 48px;
            height: 48px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .conversation-compose .send .circle i {
            font-size: 24px;
            margin-left: 5px;
          }

          /* Small Screens */

          @media (max-width: 768px) {
            .marvel-device.nexus5 {
              border-radius: 0;
              flex: none;
              padding: 0;
              max-width: none;
              overflow: hidden;
              height: 100%;
              width: 100%;
            }

            .marvel-device > .screen .chat {
              visibility: visible;
            }

            .marvel-device {
              visibility: hidden;
            }

            .marvel-device .status-bar {
              display: none;
            }

            .screen-container {
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
            }

            .conversation {
              height: calc(100vh - 55px);
            }
            .conversation .conversation-container {
              height: calc(100vh - 120px);
            }
          }
        `}
      </style>
      <Box w='full' className='marvel-device nexus5'>
        <div className='top-bar'></div>
        <div className='sleep'></div>
        <div className='volume'></div>
        <div className='camera'></div>
        <div className='screen'>
          <div className='screen-container'>
            <div className='status-bar'>
              <div className='time'></div>
              <div className='battery'>
                <i className='zmdi zmdi-battery'></i>
              </div>
              <div className='network'>
                <i className='zmdi zmdi-network'></i>
              </div>
              <div className='wifi'>
                <i className='zmdi zmdi-wifi-alt-2'></i>
              </div>
              <div className='star'>
                <i className='zmdi zmdi-star'></i>
              </div>
            </div>
            <div className='chat'>
              <div className='chat-container'>
                <div className='user-bar'>
                  <div className='back'>
                    <i className='zmdi zmdi-arrow-left'></i>
                  </div>
                  <div className='avatar'>
                    <img src='/assets/images/icon-1024x1024.png' alt='Avatar' />
                  </div>
                  <div className='name'>
                    <span>Autoinspector</span>
                    <span className='status'>online</span>
                  </div>
                  <div className='actions more'>
                    <i className='zmdi zmdi-more-vert'></i>
                  </div>
                  <div className='actions attachment'>
                    <i className='zmdi zmdi-attachment-alt'></i>
                  </div>
                  <div className='actions'>
                    <i className='zmdi zmdi-phone'></i>
                  </div>
                </div>
                <div className='conversation'>
                  <div className='conversation-container'>
                    <div className='message received'>
                      <strong>{props.subject}</strong>
                      <br />
                      {props.body}
                      <Box>
                        <Text color='gray.400'>{props.footer}</Text>
                      </Box>
                      <Box>
                        <chakra.hr my='2' />
                        <Box
                          display={'flex'}
                          alignItems='center'
                          textAlign={'center'}
                          justifyContent='center'
                        >
                          <GoLinkExternal color='#34B7F1' />
                          <Text color={'#34B7F1'} ml='1'>
                            Ir al a inspección
                          </Text>
                        </Box>
                      </Box>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Box>
    </div>
  )
}

export const MessageTemplatePreview = ({
  fields,
  channel,
}: {
  fields: IMessageTemplateSchema
  channel: DeliveryChannel
}) => {
  switch (channel) {
    case 'wsp':
      return <WhatsappPreview {...fields} />

    case 'sms':
      return <SMSPreview {...fields} />

    case 'email':
      return <EmailPreview {...fields} />

    default:
      return null
  }
}
